<template>
  <div class="auth-wrapper auth-v2 fullscreen">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <img :src="$i18n.locale === 'en' ? '//soustitreur.com/images/logo/logo-closedCaptioner.svg' : '//soustitreur.com/images/logo/logo.png'" style="height:220px;">
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- from-->
      <b-col
        lg="4"
        class="d-flex auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <!-- Locale -->
          <div
            class="horizontal-layout"
            style="height:inherit"
          >
            <div class="navbar-container d-flex content align-items-center">
              <b-navbar-nav class="nav align-items-center ml-auto">
                <locale />
              </b-navbar-nav>
            </div>
          </div>
          <!-- /Locale -->
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{ $t('Connect without password')}}
          </b-card-title>
          <code class="mb-2" color="danger" v-if="errorMsg">
            {{ $t(errorMsg) }}
          </code>
          <b-card-text class="mb-2" v-if="step === 'requestOTP'">
            {{ $t("We will send you a confirmation code.") }}
          </b-card-text>
          
          <div>
            <b-tabs align="left" v-if="step === 'requestOTP'">
              <b-tab
                title="Email"
                active
              >
                <!-- form -->
                <validation-observer
                    ref="requestOtpByEmailForm"
                    #default="{invalid}"
                >
                  <b-form
                    
                    class="auth-forgot-password-form mt-2"
                    @submit.prevent="requestOtp('email')"
                  >
                    <b-form-group
                      label-for="forgot-password-email"
                    >
                      
                      <validation-provider
                        #default="{ errors, failedRules }"
                        name="Email"
                        rules="required|email"
                      >
                        <b-form-input
                          id="forgot-password-email"
                          v-model="userEmail"
                          :state="errors.length > 0 ? false:null"
                          name="forgot-password-email"
                          placeholder="john@example.com"
                          ref="refEmail"
                        />
                        <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':'Email'}) }}</small>
                      </validation-provider>
                    </b-form-group>

                    <b-button
                      :disabled="invalid || isloading"
                      type="submit"
                      variant="primary"
                      block
                    >
                      {{ $t('Request OTP') }}
                    </b-button>
                  </b-form>
                </validation-observer>
              </b-tab>
              <b-tab title="SMS">
                <form class="auth-forgot-password-form mt-2"
                    @submit.prevent="requestOtp('phoneNumber')">
                <input
                  ref="phoneInput"
                  class="form-control"
                  id="phone"
                  @input="validatePhoneNumber"
                >
                <br/>
                <b-button
                    :disabled="!isValidNumber"
                    type="submit"
                    variant="primary"
                    block
                  >
                    {{ $t('Request OTP') }}
                  </b-button>
                </form>
              </b-tab>

            </b-tabs>
            <div v-if="step === 'verifyOTP'">
              <b-card-text class="mb-2" v-if="method === 'email'">
                {{ $t("Enter 6 digits verification code sent to your email") }}
              </b-card-text>
              <b-card-text class="mb-2" v-if="method === 'phoneNumber'">
                {{ $t("Enter 6 digits verification code sent to your phone") }}
              </b-card-text>
              <div class="d-flex justify-content-center">
                <v-otp-input
                  v-model="otp"
                  ref="otpInput"
                  input-classes="otp-input"
                  separator=" "
                  :num-inputs="6"
                  :should-auto-focus="true"
                  :is-input-num="true"
                  @on-change="handleOnChange"
                  @on-complete="handleOnComplete"
                  v-on:keyup.native.enter="verifyOTP"
                />
              </div>
              <br>
              <b-button
                :disabled='isDisabled'
                type="submit"
                variant="primary"
                block
                @click="verifyOTP"
              >
                {{ $t('Verify') }}
              </b-button>
            </div>
          </div>
          
          <p class="text-center mt-2">
            <b-link :to="{name:'Login'}">
              <feather-icon icon="ChevronLeftIcon" /> {{ $t('Back to login') }}
            </b-link>
          </p>
        </b-col>
      </b-col>
    <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BForm, BFormGroup, BFormInput, BButton, BNavbarNav, BTabs, BTab,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import Locale from '@/components/header/Locale.vue'
import Apicall from '@/libs/api-call' 
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VOtpInput from "@bachdgvn/vue-otp-input";
// import International Telephone Input
import intlTelInput from '@/libs/intl-tel-input/js/intlTelInput.js';
import utilsScript from '@/libs/intl-tel-input/js/utils.js'
import '@/libs/intl-tel-input//css/intlTelInput.css';

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    BTabs,
    BTab,
    ValidationProvider,
    ValidationObserver,
    Locale,
    BNavbarNav,
    ToastificationContent,
    VOtpInput,
  },
  data() {
    return {
      method: 'email',
      userEmail: null,
      phoneNumber: null,
      otp: '',
      isloading: false,
      isCorrectToken: {},
      errorMsg: null,
      step: 'requestOTP',
      geoinfos: this.$store.state.geoinfos,
      fastconnectToken: null,
      // validation rules
      required,
      isDisabled: true,
      cellContainer: {},
      isValidNumber: false,
    }
  },
  mounted() {
    this.getGeoInfo();
  },
  methods: {
    getGeoInfo() {
      if (Object.keys(this.$store.state.geoinfos).length === 0) {
        this.$http.get('https://gapps.soustitreur.com/').then(res => {
          this.$store.state.geoinfos = res.data;
          this.geoinfos= this.$store.state.geoinfos;
          this.generatePhoneNumber();
        })
      } else {
        this.generatePhoneNumber();
      }
    },
    requestOtp(_method) {
      if (_method === 'email') {
        this.$refs.requestOtpByEmailForm.validate().then(success => {
          if (success) {
            this.callApiRequestLoginOtp(_method);
          }
        })
      } else if (_method === 'phoneNumber') {
        if (this.phoneNumber[0] === '+') {
          this.phoneNumber = this.phoneNumber.substring(1);
        }
        this.callApiRequestLoginOtp(_method);
      }
    },
    callApiRequestLoginOtp(_method) {
      const api = new Apicall();
      this.isloading = true;
      api.requestLoginOtp(_method, this.userEmail, this.phoneNumber, this.$i18n.locale, this.geoinfos).then((response) => {
          if (response.status === 'OK') {
            this.step = 'verifyOTP';
            this.fastconnectToken = response.data.data.token;
            this.errorMsg = null;
          } else {
            this.errorMsg = this.$t(response.msg);
          }
          this.isloading = false;
      }).catch((response) => {
        this.isloading = false;
        this.errorMsg = this.$t(response.msg);
      });
    },
    verifyOTP() {
      const api = new Apicall();
      this.isloading = true;
      api.verifyLoginOTP(this.fastconnectToken, this.otp).then((response) => {
          if (response.status === 'OK') {
            window.localStorage.setItem('bearer', response.data.data.bear);
            this.errorMsg = null;
            api.isLoggedIn().then((response) => {
              if (response === true) {
                this.$router.push({name:'UserMyOrders'})
                .then(() => {
                  const name = store.state.userData.fullName ? store.state.userData.fullName : store.state.userData.email;
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: this.$t('Welcome') + ` ${name}`,
                      icon: 'CoffeeIcon',
                      variant: 'success',
                    },
                  })
                });
              }
            });
          } else {
            this.errorMsg = this.$t(response.msg);
          }
          this.isloading = false;
      }).catch((response) => {
        this.isloading = false;
        this.errorMsg = this.$t(response.msg);
      });
    },
    handleOnChange(value) {
      if (value.length === 6) {
        this.otp = value;
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    handleOnComplete(value) {
        this.otp = value;
        this.isDisabled = false;
    },
    generatePhoneNumber() {
      const input = document.querySelector("#phone");
      var countryCode = "ca";
      if(this.geoinfos){
          countryCode = this.geoinfos.COUNTRY ? this.geoinfos.COUNTRY.toLowerCase() : "ca";
      }
      this.cellContainer = intlTelInput(input, {
        utilsScript: utilsScript,
        autoPlaceholder: "aggressive",
        preferredCountries: ['fr','ca','be','us','mx'],
        initialCountry: "auto",
        geoIpLookup: function(success, failure){
            success(countryCode);
        },
      });
    },
    validatePhoneNumber() {
      const numberFormatE164 = 0; //intlTelInputUtils.numberFormat.E164
      this.phoneNumber = this.cellContainer.getNumber(numberFormatE164);
      if (this.cellContainer.isValidNumber()) {
        this.isValidNumber = true;
        this.$refs.phoneInput.classList.remove("is-invalid");
      } else {
        this.isValidNumber = false;
        this.$refs.phoneInput.classList.add("is-invalid");
      }
    }
  }
}
</script>

<style scoped>
.form-group .iti{
  position: relative;
  display: flex;
}
.v-select.form-control{
  padding: 0rem;
}
</style>
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.fullscreen {
  background-image: linear-gradient(90deg, #b6fdb2 0%, #b6fdb2 50%, #EBFFEB 100%);
}
html[dir=ltr] .content {
    margin-left: 0px;
}
.otp-input {
  width: 36px;
  height: 36px;
  padding: 5px;
  margin: 0 2px;
  font-size: 18px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  &.error {
    border: 1px solid red !important;
  }
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
